import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import {
  initConsent,
  setConsent,
  CONSENT_ACCEPTED,
  CONSENT_REJECTED,
} from 'utils/cookieConsent';
import CookieArt from './CookieArt';
import css from './css.module.scss';

const EXIT_MS = 300;

const CookieConsent = () => {
  const [t] = useTranslation('global');
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    // Restore the previous decision (load/block GTM) and only prompt when the
    // user has not made a choice yet.
    if (!initConsent()) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (value) => {
    setConsent(value);
    // play the exit animation before removing the card
    setLeaving(true);
    setTimeout(() => setVisible(false), EXIT_MS);
  };

  if (!visible) return null;

  return (
    <aside
      className={clsx(css.card, leaving && css.leaving)}
      role="dialog"
      aria-live="polite"
      aria-label={t('cookies.title')}
    >
      <CookieArt />
      <h4 className={css.title}>{t('cookies.title')}</h4>
      <p className={css.description}>{t('cookies.description')}</p>

      <div className={css.actions}>
        <button
          type="button"
          className={clsx(css.button, css.reject)}
          onClick={() => handleChoice(CONSENT_REJECTED)}
        >
          {t('cookies.reject')}
        </button>
        <button
          type="button"
          className={clsx(css.button, css.accept)}
          onClick={() => handleChoice(CONSENT_ACCEPTED)}
        >
          {t('cookies.accept')}
        </button>
      </div>
    </aside>
  );
};

export default CookieConsent;
